var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col min-h-screen"},[_c('main',{staticClass:"flex-grow"}),_c('footer',{staticClass:"sticky bottom-0 p-2 bg-white"},[_c('div',{staticClass:"p-2 flex justify-end"},[_c('MenuItem')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }